import axios from 'axios';
export default class Http {
  constructor(config) {
    this.config = config;
    this.http = axios.create({
      baseURL: config.baseUrl,
      headers: config.headers,
      withCredentials: true,
      timeout: config.timeout
    });
  }

  _get(uri, params) {
    return this._request(uri, 'get', params, null);
  }

  _post(uri, params, data) {
    return this._request(uri, 'post', params, data);
  }

  _put(uri, params, data) {
    return this._request(uri, 'put', params, data);
  }

  _delete(uri, params) {
    return this._request(uri, 'delete', params, null);
  }

  _request(uri, method, params, data) {
    return new Promise((resolve, reject) => {
      this.http.request({
          url: uri,
          method: method,
          params: params,
          data: data
        })
        .then((res) => {
          // "";
          switch (res.data.code) {
            case 500:
            case 501:
            case 503:
              reject({
                code: res.data.code,
                msg: res.data.msg
              });
              break;
            default:
              resolve(res);
          }
        })
        .catch((err) => {
          let _this = this
          if (err.response && err.response.status == 401) {
            let url = new URL(_this.config.baseUrl + '/api/Login/GetAuthorize2');
            url.searchParams.append('InstitutionId', _this.config.headers.CurrentInstitutionId);
            url.searchParams.append('returnUrl', decodeURIComponent(window.location.href));
            window.location.href = url.href;

          
          }
          reject(err);
        })
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/Core/Http.js